"use client";

import Link from "@/app/[lang]/_components/Link";
import { createT } from "@/app/[lang]/_utils/create-t";
import { getLangFromPathname } from "@/app/[lang]/_utils/get-lang-from-pathname";
import Image from "@/components/Image";
import { Button } from "@borderless/ui/components/button";
import { usePathname } from "next/navigation";
import { type FC } from "react";
import { HeaderNav } from "../HeaderNav";
import dictionary from "./t.json";

const t = createT(dictionary);

export const NotFoundPage: FC = () => {
  const pathname = usePathname();
  const lang = getLangFromPathname(pathname) ?? "en";

  return (
    <div>
      <HeaderNav lang={lang} />
      <main className="flex min-h-[calc(100dvh-var(--header-height))] w-full items-center justify-center p-(--main-padding)">
        <div className="max-w-2xl space-y-4 text-center">
          <div className="text-base">{t("404 - Not Found", lang)}</div>
          <h1 className="font-(family-name:--font-caprasimo) text-2xl md:text-4xl">
            {t("Oops, I'm not sure where it went!", lang)}
          </h1>
          <Image
            src="/images/not-found.webp"
            alt="Not Found"
            width={320}
            height={320}
            className="mx-auto size-40 md:size-80"
          />
          <p className="text-base">
            {t(
              "We looked everywhere, but this page seems to have vanished into thin air.",
              lang,
            )}
          </p>
          <Button variant="secondary" asChild>
            <Link href="/">{t("Go back home", lang)}</Link>
          </Button>
        </div>
      </main>
    </div>
  );
};
